var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',{attrs:{"rules":"max:10000"},scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_c('v-textarea',{attrs:{"label":_vm.name,"outlined":"","error-messages":errors},on:{"change":_vm.emitFieldData},model:{value:(_vm.paragraphText),callback:function ($$v) {_vm.paragraphText=$$v},expression:"paragraphText"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }